import { motion } from 'framer-motion';

const StatusCard = ({ 
  title, 
  value, 
  subtitle, 
  icon: Icon, 
  trend, 
  status = 'default' // online, offline, warning, default
}) => {
  const statusColors = {
    online: 'border-green-500/30 bg-green-500/5',
    offline: 'border-red-500/30 bg-red-500/5',
    warning: 'border-yellow-500/30 bg-yellow-500/5',
    default: 'border-white/10 bg-white/5'
  };

  const statusIconColors = {
    online: 'text-green-400 bg-green-500/20',
    offline: 'text-red-400 bg-red-500/20',
    warning: 'text-yellow-400 bg-yellow-500/20',
    default: 'text-violet-400 bg-violet-500/20'
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`
        relative overflow-hidden rounded-xl border backdrop-blur-md p-5
        transition-all duration-300 hover:scale-[1.02]
        ${statusColors[status]}
      `}
    >
      {/* Background Glow */}
      {status === 'online' && (
        <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/10 rounded-full blur-3xl" />
      )}
      
      <div className="relative flex items-start justify-between">
        <div className="flex-1">
          <p className="text-gray-400 text-sm uppercase tracking-wider mb-1">{title}</p>
          <p className="font-heading font-bold text-3xl text-white">{value}</p>
          {subtitle && (
            <p className="text-gray-500 text-sm mt-1">{subtitle}</p>
          )}
          {trend && (
            <p className={`text-sm mt-2 ${trend > 0 ? 'text-green-400' : 'text-red-400'}`}>
              {trend > 0 ? '↑' : '↓'} {Math.abs(trend)}%
            </p>
          )}
        </div>
        
        {Icon && (
          <div className={`p-3 rounded-lg ${statusIconColors[status]}`}>
            <Icon className="w-6 h-6" />
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default StatusCard;
